/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const AssignmentErrorIcon = /*#__PURE__*/ createSvgIcon(
  'AssignmentErrorIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <circle cx={10} cy={10} r={9.167} fill="currentColor" />
          <path
            d="M10 11.25a.605.605 0 01-.445-.18.605.605 0 01-.18-.445V6.25c0-.177.06-.326.18-.445.12-.12.268-.18.445-.18s.325.06.445.18.18.268.18.445v4.375c0 .177-.06.325-.18.445a.605.605 0 01-.445.18zm0 3.125a.605.605 0 01-.445-.18.605.605 0 01-.18-.445c0-.177.06-.325.18-.445s.268-.18.445-.18.325.06.445.18.18.268.18.445-.06.325-.18.445a.605.605 0 01-.445.18z"
            fill="#fff"
          />
        </>
      ),
    },
  },
  false
);

export default AssignmentErrorIcon;
